module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Krypton-cropped.88bd288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Krypton-cropped.jpg
// module id = 8j0f
// module chunks = 0